import { IDefineCommand, IQuery } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Resource } from '../builders/resource_builder';
import { ResourceInfo } from '../builders/resource_info_builder';
import { ResourceLocation } from '../builders/resource_location_builder';

angular
  .module('capability-ng-resources')
  .factory(
    'loadResourcesCommand',
    (
      $http: ng.IHttpService,
      ngResourceDatastore: IDatasource<Resource>,
      ngResourceInfoDatastore: IDatasource<ResourceInfo>,
      ngResourceLocationDatastore: IDatasource<ResourceLocation>,
      defineCommand: IDefineCommand
    ) => {
      return defineCommand('loadResourcesCommand', (deferred: ng.IDeferred<IQuery[]>) => {
        $http
          .get('resource/')
          .then((res: any) => {
            ngResourceDatastore.write(res.data.resource);
            ngResourceInfoDatastore.write(res.data.resource_detail);
            ngResourceLocationDatastore.write(res.data.location);
            ORM.run();
            deferred.resolve();
          })
          .catch((err) => {
            deferred.reject(err);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/commands/load_resources_command.ts